import {concat, flow, get, reduce} from '@logistics-frontend/utils'

import {Poll, PollQuestion, Subpoll} from 'src/api/cargo-c2c'

export const getQuestions = flow<[Poll], Subpoll[], PollQuestion[]>(
  get('subpolls'),
  reduce((acc: PollQuestion[], {questions}: Subpoll) => concat(acc, questions), []),
)
